import { createApiConfig } from '~/apiConfig/index.js';

export default defineNuxtPlugin(() => {
  const cfg = useRuntimeConfig();
  const baseUrl = `https://${cfg.public.APP_BACKEND_API_URL}/api`;

  const useApi = createApiConfig(baseUrl);

  return {
    provide: {
      useApi,
    },
  };
});
